import { UserIdentifierType } from '../analytics-event-manager/IAnalyticsEventManager';
import { CONTROL_VARIANT } from './ExperimentManager';
import { IExperiment } from './IExperimentManager';

export const EXP_VAR_TREATMENT = 'treatment';

export enum ExperimentNames {
  PLACEHOLDER = 'PLACEHOLDER', // unused placeholder to ensure correct types
  BULK_DISCOUNT = 'BULK_DISCOUNT ',
  NEW_PROMO_CODE = 'NEW_PROMO_CODE ',
  POST_CHECKOUT_UPSELL_RECS = 'POST_CHECKOUT_UPSELL_RECS',
  ANY_DAY_DELIVERY = 'ANY_DAY_DELIVERY',
  HAMBURGER_MENU_REDESIGN = 'HAMBURGER_MENU_REDESIGN',
  MEAL_PLAN_ADD_ONS = 'MEAL_PLAN_ADD_ONS',
  MEAL_PLAN_CHECKOUT_REVAMP_V3 = 'MEAL_PLAN_CHECKOUT_REVAMP_V3',
  MEAL_PLAN_DISH_MODAL_REFRESH = 'meal_plan_dish_modal_refresh',
  WSS_FINALIZE_PAYMENT_ELEMENT_V1 = 'wss_finalize_payment_element_v1',
  WSS_PRICE_UPDATE_SF_V2 = 'wss_price_update_sf_v2',
  WSS_PRICE_UPDATE_LA_V2 = 'wss_price_update_la_v2',
  VARIABLE_SERVICE_FEE = 'VARIABLE_SERVICE_FEE',
  MARKETPLACE_VARIABLE_SERVICE_FEE = 'MARKETPLACE_VARIABLE_SERVICE_FEE',
  DYNAMIC_SHEF_SORTING = 'DYNAMIC_SHEF_SORTING',
  MEAL_PLAN_SEARCH_V2 = 'MEAL_PLAN_SEARCH_V2',
  EXPRESS_CHECKOUT_V2 = 'EXPRESS_CHECKOUT_V2',
  PRICING_CURVE_NY_V1 = 'PRICING_CURVE_NY_V1',
  PRICING_CURVE_BAY_LA_V1 = 'PRICING_CURVE_BAY_LA_V1',
  PRICING_CURVE_CHI_SEA_V1 = 'PRICING_CURVE_CHI_SEA_V1',
  PRICING_CURVE_AUS_BOS_DC_V1 = 'PRICING_CURVE_AUS_BOS_DC_V1',
  FAVORITES_V2 = 'favorites_v2',
  PRICING_CURVE_BAY_LA_V2 = 'PRICING_CURVE_BAY_LA_V2',
  PRICING_CURVE_NY_V2 = 'PRICING_CURVE_NY_V2',
  PRICING_CURVE_AUS_V2 = 'PRICING_CURVE_AUS_V2',
  PRICING_CURVE_SEA_V2 = 'PRICING_CURVE_SEA_V2',
  PRICING_CURVE_CHI_V2 = 'PRICING_CURVE_CHI_V2',
  PRICING_CURVE_DC_V2 = 'PRICING_CURVE_DC_V2',
  PRICING_CURVE_BOS_V2 = 'PRICING_CURVE_BOS_V2',
  WSS_CUISINE_CAROUSEL_V3 = 'WSS_CUISINE_CAROUSEL_V3',
  LEAD_CAPTURE_MODAL_V2 = 'LEAD_CAPTURE_MODAL_V2',
  WSS_FLEXIBLE_SERVINGS_V2 = 'WSS_FLEXIBLE_SERVINGS_V2',
  WSS_FLEXIBLE_SERVINGS_V3 = 'WSS_FLEXIBLE_SERVINGS_V3',
  LP_DISH_STORIES = 'LP_DISH_STORIES',
  LP_FULL_BLEED_VIDEO = 'LP_FULL_BLEED_VIDEO',
  LP_HOW_IT_WORKS = 'LP_HOW_IT_WORKS',
  LP_FACTOR_COMP = 'LP_FACTOR_COMP',
  LP_LOCAL_DALLAS = 'LP_LOCAL_DALLAS',
  LP_LOCAL_HOUSTON = 'LP_LOCAL_HOUSTON',
  LP_LOCAL_GOOGLE = 'LP_LOCAL_GOOGLE',
  MEAL_PLAN_ATTRIBUTION_MODAL_V2 = 'meal_plan_attribution_modal_v2',
  INTAKE_HOUSEHOLD_CONSOLIDATION_V2 = 'INTAKE_HOUSEHOLD_CONSOLIDATION_V2',
  INTAKE_OPTIMIZATION = 'INTAKE_OPTIMIZATION',
  INTAKE_SETTINGS_BEFORE_CALENDAR = 'INTAKE_SETTINGS_BEFORE_CALENDAR',
  SIGN_UP_GATE_REDESIGN_V2 = 'SIGN_UP_GATE_REDESIGN_V2',
  SIDES_CATEGORY_CAROUSEL = 'SIDES_CATEGORY_CAROUSEL',
  REUSABLE_PACKAGING_LA = 'REUSABLE_PACKAGING_LA',
  REUSABLE_PACKAGING_SEA = 'REUSABLE_PACKAGING_SEA',
  WSS_REUSABLE_OPT_IN = 'WSS_REUSABLE_OPT_IN',
  WSS_DESSERTS_PLACEMENT = 'WSS_DESSERTS_PLACEMENT',
  DEFAULT_PLAN_UPDATE = 'DEFAULT_PLAN_UPDATE',
  HIDE_HOMEPAGE_ONE_TIME_TX = 'HIDE_HOMEPAGE_ONE_TIME_TX',
}

export const ActiveExperiments: readonly IExperiment[] = [
  {
    name: ExperimentNames.BULK_DISCOUNT,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.NEW_PROMO_CODE,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.POST_CHECKOUT_UPSELL_RECS,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.ANY_DAY_DELIVERY,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.HAMBURGER_MENU_REDESIGN,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 100,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 0,
      },
    ],
  },
  {
    name: ExperimentNames.MEAL_PLAN_ADD_ONS,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.MEAL_PLAN_CHECKOUT_REVAMP_V3,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.MEAL_PLAN_DISH_MODAL_REFRESH,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 100,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 0,
      },
    ],
  },
  {
    name: ExperimentNames.WSS_PRICE_UPDATE_SF_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 100,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 0,
      },
    ],
  },
  {
    name: ExperimentNames.WSS_PRICE_UPDATE_LA_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 100,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 0,
      },
    ],
  },
  {
    name: ExperimentNames.WSS_FINALIZE_PAYMENT_ELEMENT_V1,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 0,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.VARIABLE_SERVICE_FEE,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.MARKETPLACE_VARIABLE_SERVICE_FEE,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.DYNAMIC_SHEF_SORTING,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.MEAL_PLAN_SEARCH_V2,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    // Single gate for the consolidated Express Checkout (Apple Pay / Google Pay /
    // Link), shown on the meal-plan finalize page regardless of device wallet.
    // Replaces the retired EXPRESS_CHECKOUT_V1 / EXPRESS_CHECKOUT_ON_REVIEW(_V2).
    name: ExperimentNames.EXPRESS_CHECKOUT_V2,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    // Superseded by PRICING_CURVE_NY_V2; rollout is 0 so no new users
    // bucket into V1. Existing V1 subscribers are grandfathered via their
    // meal_plan_type.experiment_name and never call getVariant again.
    name: ExperimentNames.PRICING_CURVE_NY_V1,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    // Superseded by PRICING_CURVE_BAY_LA_V2; rollout is 0 so no new users
    // bucket into V1. Existing V1 subscribers are grandfathered via their
    // meal_plan_type.experiment_name and never call getVariant again.
    name: ExperimentNames.PRICING_CURVE_BAY_LA_V1,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.PRICING_CURVE_BAY_LA_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.PRICING_CURVE_NY_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    // Split into per-region PRICING_CURVE_CHI_V2 / PRICING_CURVE_SEA_V2; rollout 0
    // so no new users bucket into the group. Existing subscribers are grandfathered
    // via meal_plan_type.experiment_name and never call getVariant again.
    name: ExperimentNames.PRICING_CURVE_CHI_SEA_V1,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    // Split into per-region PRICING_CURVE_AUS_V2 / PRICING_CURVE_DC_V2 /
    // PRICING_CURVE_BOS_V2; rollout 0 so no new users bucket into the group.
    // Existing subscribers are grandfathered via meal_plan_type.experiment_name.
    name: ExperimentNames.PRICING_CURVE_AUS_BOS_DC_V1,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.PRICING_CURVE_AUS_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.PRICING_CURVE_SEA_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.PRICING_CURVE_CHI_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.PRICING_CURVE_DC_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.PRICING_CURVE_BOS_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.FAVORITES_V2,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    name: ExperimentNames.WSS_CUISINE_CAROUSEL_V3,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.LEAD_CAPTURE_MODAL_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.WSS_FLEXIBLE_SERVINGS_V2,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.WSS_FLEXIBLE_SERVINGS_V3,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    // Held at rollout 0 rather than removed: useLpDishStoriesExperiment and the
    // Dish Stories page still reference this experiment.
    name: ExperimentNames.LP_DISH_STORIES,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 0,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 50,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 50,
      },
    ],
  },
  {
    name: ExperimentNames.LP_FULL_BLEED_VIDEO,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.LP_HOW_IT_WORKS,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.LP_FACTOR_COMP,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 0 },
      { name: EXP_VAR_TREATMENT, weight: 100 },
    ],
  },
  {
    name: ExperimentNames.LP_LOCAL_DALLAS,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.LP_LOCAL_HOUSTON,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.LP_LOCAL_GOOGLE,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.INTAKE_HOUSEHOLD_CONSOLIDATION_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.INTAKE_OPTIMIZATION,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 0 },
      { name: EXP_VAR_TREATMENT, weight: 100 },
    ],
  },
  {
    name: ExperimentNames.INTAKE_SETTINGS_BEFORE_CALENDAR,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.MEAL_PLAN_ATTRIBUTION_MODAL_V2,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      {
        name: CONTROL_VARIANT,
        weight: 0,
      },
      {
        name: EXP_VAR_TREATMENT,
        weight: 100,
      },
    ],
  },
  {
    // Same flag as the retired SIGN_UP_GATE_REDESIGN; new name so bucketing drops stale assignments.
    name: ExperimentNames.SIGN_UP_GATE_REDESIGN_V2,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.SIDES_CATEGORY_CAROUSEL,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.REUSABLE_PACKAGING_LA,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 25 },
      { name: EXP_VAR_TREATMENT, weight: 75 },
    ],
  },
  {
    name: ExperimentNames.REUSABLE_PACKAGING_SEA,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.WSS_REUSABLE_OPT_IN,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.WSS_DESSERTS_PLACEMENT,
    userIdentifierType: UserIdentifierType.USER_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 0 },
      { name: EXP_VAR_TREATMENT, weight: 100 },
    ],
  },
  {
    name: ExperimentNames.DEFAULT_PLAN_UPDATE,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
  {
    name: ExperimentNames.HIDE_HOMEPAGE_ONE_TIME_TX,
    userIdentifierType: UserIdentifierType.DEVICE_ID,
    rollout: 100,
    variants: [
      { name: CONTROL_VARIANT, weight: 50 },
      { name: EXP_VAR_TREATMENT, weight: 50 },
    ],
  },
];
